export default "__VITE_ASSET__Du$sX3E___"